import cx from "classnames";
import React from "react";

import { CLASS_IMAGE_WRAPPER } from "./constants";

interface PromotionCardImageWrapperProps {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const PromotionCardImageWrapper: React.FC<
  PromotionCardImageWrapperProps
> = ({ className, children, ...other }) => {
  const classes = cx(CLASS_IMAGE_WRAPPER, className);
  return (
    <div className={classes} {...other}>
      {children}
    </div>
  );
};

PromotionCardImageWrapper.displayName = "PromotionCardImageWrapper";
